import React, { useState } from 'react';
import './Agriculture.css';
import Pic from '../assets/PopAsal_img.png';
import PdfViewer5 from '../About/PdfViewer5';
import Loader from '../Loader/Loader'; // import the Loader component


const PopAsal = () => {
  const [showPdfViewer5, setShowPdfViewer5] = useState(false);
  const [loading, setLoading] = useState(false); // add state for loading indicator

  function handleReadMoreClick() {
    setLoading(true); // set loading state to true
    setTimeout(() => {
      setShowPdfViewer5(true);
      setLoading(false); // set loading state to false when the PDF viewer is ready
    }, 5000);
  }

  return (
    <div className="image-description">
      <div className="description">
        <h2>Population Density in ASAL counties (No. per sq. Km)</h2>
        {loading ? (
          <Loader /> // show the loading indicator
        ) : showPdfViewer5 ? (
          <PdfViewer5 onClose={() => setShowPdfViewer5(false)} />
        ) : (
          <>
            <p>The ASALs are sparsely populated areas with the arid areas having an average density population of 20.1 people per square kilometer. This is mainly  ...</p>
            <button className="read-more-button" onClick={handleReadMoreClick}>Read More</button>
          </>
        )}
      </div>
      <img src={Pic} alt='asals' className="image" />
    </div>
  );
};

export default PopAsal;
